import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { InvoiceGlBreakoutItem } from 'src/services/useInvoiceGlBreakoutApi';
import GridCellBase from '../GridCellBase';
import ExpandCollapseCell from './ExpandCollapseCell';

const GLSummaryDetailCell = (props: GridCellProps) => {
  let { expanded = false } = props.dataItem;
  const [cellClickFns] = useContext(EditCellContext);
  const { setData } = cellClickFns?.(null) as any;
  const { dataItem } = props;

  const handleExpendClick = useCallback(() => {
    setData?.((pre: InvoiceGlBreakoutItem[]) =>
      pre.map((glCode: InvoiceGlBreakoutItem) => ({
        ...glCode,
        expanded: glCode.rowId === dataItem.rowId ? !dataItem.expanded : glCode.expanded,
      }))
    );
  }, [dataItem.expanded, dataItem.rowId, setData]);

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <ExpandCollapseCell
        title="Expand/Collapse"
        expand={expanded}
        onExpand={handleExpendClick}
        plusIconColor="#0e80b4"
        minusIconColor="#0e80b4"
      />
    </GridCellBase>
  );
};

export default GLSummaryDetailCell;
